import { MissionKindRestrictedEnum, MissionStatusEnum } from "src/graphql/generated/types";

export const MissionStatusLabel: {
  [K in MissionStatusEnum]: string;
} = {
  [MissionStatusEnum.Open]: "Enregistrée",
  [MissionStatusEnum.WorkInProgress]: "En cours",
  [MissionStatusEnum.Summoned]: "Convoquée",
  [MissionStatusEnum.MinutesSent]: "PV envoyé",
  [MissionStatusEnum.Finished]: "Clôturée",
  [MissionStatusEnum.Close]: "Clôturée",
  [MissionStatusEnum.Ended]: "Clôturée",
};

export const MissionKindLabel: {
  [K in MissionKindRestrictedEnum]: string;
} = {
  [MissionKindRestrictedEnum.MissionGeneralAssembly]: "Assemblée générale",
  [MissionKindRestrictedEnum.MissionIncident]: "Dépannage/Réparation",
  [MissionKindRestrictedEnum.MissionRepair]: "Travaux",
  [MissionKindRestrictedEnum.MissionTrusteeCouncil]: "Conseil syndical",
  [MissionKindRestrictedEnum.MissionVisit]: "Visite d'immeuble",
};
